import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=2b59f0e4"
import script from "./SendMessageModal.vue?vue&type=script&lang=js"
export * from "./SendMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports